import { render } from "./PlusIcon.vue?vue&type=template&id=f96a4530"
const script = {}
script.render = render

export default script